<template>
  <div id="tab" class="el-container">
    <div class="el-main">
      <el-card shadow="never">
        <div slot="header">
          <span>特殊价格</span>
        </div>
        <el-form :inline="true" class="query_form" size="small">
          <el-form-item label="日期">
            <date-picker v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
          </el-form-item>
          <el-form-item label="客户" prop="customer.selected">
            <el-select class="select_multiple" ref="customerSelectRef" style="width: 100%;" v-model="queryForm.customer.selected" value-key="value" multiple clearable placeholder="请选择客户名称" @click.native="customerInputFocus">
              <el-option v-for="item in queryForm.customer.list" :key="item.value" :label="item.text" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuery">查询</el-button>
            <el-button @click="addDialog">新增</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="table" v-loading="tableLoading">
        <el-table :data="tableData" border stripe size="mini" height="100%" max-height="100%" style="width: 100%" @row-dblclick="handleTableDBClick">
          <el-table-column class-name="index" type="index" width="30"></el-table-column>
          <el-table-column prop="planDesc" label="特价方案" width="150">
            <template slot="header" slot-scope="{ column }">
              <el-popover placement="bottom" trigger="click" :ref="`popover_${column.property}`" @show="popoverShow(column.property)">
                <div class="query_btn_group">
                  <el-input v-model="queryForm.planDesc.selected" placeholder="输入特价方案搜索" clearable></el-input>
                  <el-button type="text" @click="tableFilter(column.property)">筛选</el-button>
                </div>
                <div slot="reference" :class="['reference', queryForm.planDesc.isFilter ? 'highlight' : '' ]"><label>特价方案</label><i class='el-icon-arrow-down'></i></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="itemSpec" label="日期" width="170">
            <template slot-scope="{ row }">
              <span>{{row.beginDate}} - {{row.endDate}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="modifyDateTime" label="最后编辑时间" width="150"></el-table-column>
          <el-table-column prop="modifyUserName" label="编辑人" width="100"></el-table-column>
          <el-table-column prop="isEnabled" label="状态" width="100">
            <template slot-scope="{ row }">
              <span>{{row.isEnabled != 'Y' ? '作废' : '启用'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="caozuo" label="操作" width="100" class-name="caozuo">
            <template slot-scope="scope">
              <div style="width: 100%;display: flex;flex-direction: row; justify-content: center;">
                <el-tooltip :hide-after="2000" class="item" effect="dark" content="复制" placement="top">
                  <el-button @click="copyRow(scope)" icon="el-icon-copy-document" type="text"></el-button>
                </el-tooltip>
                <el-tooltip :hide-after="2000" class="item" effect="dark" :content="scope.row.isEnabled != 'Y' ? '启用' : '作废'" placement="top">
                  <el-button @click="cancelRow(scope)" icon="iconfont icon-zuofei" type="text"></el-button>
                </el-tooltip>
                <el-tooltip :hide-after="2000" class="item" effect="dark" content="删除" placement="top">
                  <el-button @click="deleteRow(scope)" icon="el-icon-delete" type="text"></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog width="90%" :title="dialogStatus == 'add' ? '添加' : (dialogStatus == 'edit' ? '编辑' : '复制')" :visible.sync="dialogVisible" custom-class="el-dialog-common dialog" @closed="dialogClosed" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="main el-main">
        <el-card shadow="never">
          <div>
            <el-form :inline="true" class="query_form" size="small">
              <el-form-item>
                <span slot="label"><span style="color: #f56c6c; margin-right: 4px;">*</span>日期</span>
                <date-picker style="width: 100%;" v-model="dialogQueryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
              </el-form-item>
            </el-form>
            <el-form :inline="true" class="query_form" size="small">
              <el-form-item prop="planDesc.selected">
                <span slot="label"><span style="color: #f56c6c; margin-right: 4px;">*</span>特价方案</span>
                <el-input v-model="dialogQueryForm.planDesc.selected" placeholder="请输入特价方案" clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="备注" prop="remark.selected">
                <el-input v-model="dialogQueryForm.remark.selected" placeholder="请输入备注" clearable>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-form :inline="true" class="query_form" size="small">
              <el-form-item label="特价范围" prop="customerType.selected">
                <el-radio-group v-model="dialogQueryForm.customerType.selected" @change="customerTypeChange">
                  <el-radio label="C">所有客户(所有新增客户都会执行此方案)</el-radio>
                  <el-radio label="B">指定片区(指定片区新增的客户会指定此方案)</el-radio>
                  <el-radio label="A">指定客户(只针对选定的客户执行此方案)</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <div class="table dialogTable" v-loading="tableLoading">
          <collapsePanel title="商品类别">
            <cascaderPanel @get-product-data="getProductData" :config="{ firstId: 'brandID' }" :rightArgs="{isPage: 'N'}" :leftArgs="{isPage: 'N'}"></cascaderPanel>
          </collapsePanel>
          <el-table :data="dialogTableData" border stripe size="mini" height="100%" max-height="100%" style="width: 100%" v-loading="dialogTableLoading" @cell-click="tableCellClick">
            <el-table-column class-name="index" type="index" width="30"></el-table-column>
            <el-table-column width="48">
              <template slot-scope="scope">
                <div style="width: 100%;display: flex;flex-direction: row; justify-content: center;">
                  <el-button icon="el-icon-plus" type="text" :style="scope.$index + 1 == dialogTableData.length ? 'color: red;' : ''" @click="addDialogRow(scope.$index + 1)"></el-button>
                  <el-button icon="el-icon-delete" type="text" @click="deleteDialogRow(scope)" style="margin: 0;"></el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="itemName" label="商品" width="150" align="center">
              <template slot-scope="{ row, $index }">
                <selectByProductNew width="500" isCheckbox v-if="row.itemNameIsShow" :row="row" url="/Account/promotionDefineDetailForVue/selectPromotionItemPriceListForVue.html" :parameter="parameter" @hide="() => {row.itemNameIsShow = false}" @select="itemNameSelect($event, row, $index, 'salSpecialPrice')">
                  <u-table-column prop="itemName" label="商品"></u-table-column>
                  <u-table-column prop="itemSpec" label="规格" width="100"> </u-table-column>
                </selectByProductNew>
                <span v-else>{{row['itemName']}}</span>
              </template>
            </el-table-column>
            <el-table-column label="原价" width="140" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.itemName">
                  <span v-show="scope.row.salUnitName">
                    <span style="min-width: 40px; display: inline-block; text-align: center;">{{Number((Number(scope.row.salPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.salUnitName}}</span>
                  </span>
                  <span v-show="scope.row.midUnitName">
                    <span style="min-width: 40px; display: inline-block; text-align: center;">{{Number((Number(scope.row.midPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.midUnitName}}</span>
                  </span>
                  <span v-show="scope.row.salConversion != 1 && scope.row.invUnitName">
                    <span style="min-width: 40px; display: inline-block; text-align: center;">{{Number((Number(scope.row.invPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.invUnitName}}</span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="特价" width="140" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.itemName">
                  <span v-show="scope.row.salUnitName">
                    <el-input-number v-if="scope.row.salSpecialPriceIsShow" size="mini" style="width: 40px;" v-focus v-model.number="scope.row.salSpecialPrice" :controls="false" :min="0" :precision="4" @blur="numberInputBlur($event, scope, 'salSpecialPrice')" @change="handlePriceChange($event, scope, 'salSpecialPrice')" @keydown.enter.right.native="numberInputBlur('', scope, 'salSpecialPrice', scope.row.midUnitName ? 'midSpecialPrice' : (scope.row.salConversion != 1 ? 'invSpecialPrice' : 'itemName'))" @keydown.left.native="numberInputBlur('', scope, 'salSpecialPrice', 'itemName')"></el-input-number>
                    <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'salSpecialPrice' })">{{Number((Number(scope.row.salSpecialPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.salUnitName}}</span>
                  </span>
                  <span v-show="scope.row.midUnitName">
                    <el-input-number v-if="scope.row.midSpecialPriceIsShow" size="mini" style="width: 40px;" v-focus v-model.number="scope.row.midSpecialPrice" :controls="false" :min="0" :precision="4" @blur="numberInputBlur($event, scope, 'midSpecialPrice')" @change="handlePriceChange($event, scope, 'midSpecialPrice')" @keydown.enter.right.native="numberInputBlur('', scope, 'midSpecialPrice', 'invSpecialPrice')" @keydown.left.native="numberInputBlur('', scope, 'midSpecialPrice', 'salSpecialPrice')"></el-input-number>
                    <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'midSpecialPrice' })">{{Number((Number(scope.row.midSpecialPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.midUnitName}}</span>
                  </span>
                  <span v-show="scope.row.salConversion != 1 && scope.row.invUnitName">
                    <el-input-number v-if="scope.row.invSpecialPriceIsShow" size="mini" style="width: 40px;" v-focus v-model.number="scope.row.invSpecialPrice" :controls="false" :min="0" :precision="4" @blur="numberInputBlur($event, scope, 'invSpecialPrice')" @change="handlePriceChange($event, scope, 'midSpecialPrice')" @keydown.enter.right.native="numberInputBlur('', scope, 'invSpecialPrice', 'itemName')" @keydown.left.native="numberInputBlur('', scope, 'invSpecialPrice', scope.row.midUnitName ? 'midSpecialPrice' : 'salSpecialPrice')"></el-input-number>
                    <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'invSpecialPrice' })">{{Number((Number(scope.row.invSpecialPrice) || 0).toFixedRoundUp(4))}}</span>
                    <span>{{scope.row.invUnitName}}</span>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <collapsePanel title="特价范围" placement="right">
            <template slot="title" v-if="dialogQueryItem.customerType != 'C'">
              <span>特价范围</span>
              <el-button style="margin-right: 12px; padding: 0;" type="primary" size="mini" @click="customerTypeChange(dialogQueryItem.customerType)">编辑</el-button>
            </template>
            <div class="customerType">
              <el-scrollbar>
                <li v-if="dialogQueryItem.customerType == 'C'">所有客户</li>
                <ul v-else-if="dialogQueryItem.customerType == 'B'">
                  <li v-for="item in domainSelection" :key="item.domainID">{{item.text}}</li>
                </ul>
                <ul v-else-if="dialogQueryItem.customerType == 'A'">
                  <li v-for="item in promotionCustomerInfo" :key="item.value">{{item.text}}</li>
                </ul>
              </el-scrollbar>
            </div>
          </collapsePanel>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="onSubmit" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择片区" :visible.sync="dialogDomainVisible" custom-class="el-dialog-common dialogDomain" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false">
      <el-card shadow="never" class="cardDomain">
        <cascaderPanel v-if="dialogDomainVisible" ref="cascaderPanelDomain" isCheckbox :defaultCheckedKeys="domainSelection" :config="{ firstId: 'parentDomainID' }" :leftArgs="{url: '/Account/domainDefine/getDomainListForVue.html', isPage: 'N'}" :rightArgs="{url: '/Account/domainDefine/getSmallDomainListForVue.html', isPage: 'N'}"></cascaderPanel>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDomainVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="domainSelect" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择客户" width="90%" :visible.sync="dialogCustomerVisible" custom-class="el-dialog-common dialogDomain dialogCustomer" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false">
      <customerSelect v-if="dialogCustomerVisible" @get-customer="getCustomer" :defaultCheckedKeys="promotionCustomerInfo"></customerSelect>
    </el-dialog>
  </div>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import cascaderPanel from '@/components/common/cascaderPanel.vue'
import collapsePanel from '@/components/common/collapsePanel.vue'
import selectByProductNew from '@/components/common/selectByProductNew.vue'
import customerSelect from '@/components/common/customerSelect.vue'
import { toRawType, getResultArray, toFixedRe, pickerOptions, getAddDate, getNowFormatDate } from '@/assets/js/common.js'
export default {
  components: {
    datePicker,
    collapsePanel,
    cascaderPanel,
    selectByProductNew,
    customerSelect
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").onfocus = function (e) {
          e.currentTarget.select();
        };
        el.querySelector("input").focus();
      },
    },
  },
  name: 'SpecialPrice',
  data() {
    return {
      pickerOptions: pickerOptions,
      queryForm: {
        planDesc: { submitName: 'planDesc', selected: '', isFilter: false },
        billDate: { submitName: 'billDate', selected: [] },
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
      },
      params: {
        page: 1,
        size: 10,
        beginDate: '',
        endDate: '',
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      dialogVisible: false,
      dialogStatus: 'add',
      dialogParams: {
        id: ''
      },
      parameter: {
        brandID: '',
        itemTypeID: ''
      },
      dialogQueryForm: {
        billDate: { submitName: 'billDate', selected: [] },
        planDesc: { submitName: 'planDesc', selected: '' },
        remark: { submitName: 'remark', selected: '' },
        customerType: { submitName: 'customerType', selected: 'C' },
        id: { submitName: 'id', selected: '' },
      },
      dialogTableLoading: false,
      dialogTableData: [],
      dialogCustomerVisible: false,
      promotionCustomerInfo: [],
      dialogDomainVisible: false,
      domainSelection: [],
      customerTypeList: {
        A: '指定客户',
        B: '指定片区',
        C: '所有客户',
      }
    }
  },
  computed: {
    dialogQueryItem() {
      let tempItem = {}
      Object.values(this.dialogQueryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          console.log(item)
          tempItem['beginDate'] = item.selected ? (item.selected[0] || '') : ''
          tempItem['endDate'] = item.selected ? (item.selected[1] || '') : ''
          return false
        } else if (toRawType(item.selected) == 'Array') {
          tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'Object') {
          tempItem[item.submitName] = item.selected.value || ''
        } else {
          if (item.selected) tempItem[item.submitName] = item.selected
        }
      })
      return tempItem
    }
  },
  created() {
    this.getTableList()
    this.dialogTableData = this.pushItem(20)
  },
  mounted() {
    window.top.addEventListener('message',this.messageOfSelect)
  },
  beforeDestroy() {
    window.top.removeEventListener('message', this.messageOfSelect)
  },
  watch: {
    dialogTableData (val) {
      val.forEach((item, index) => {
        item['lineNum'] = index + 1
      })
    }
  },
  methods: {
    pushItem (length = 20) {
      const tempItem = []
      for (let i = 0; i < length; i++) {
        tempItem.push({unitQty: 0})
      }
      return tempItem
    },
    addDialogRow (index) {
      if (index === this.dialogTableData.length) {
        this.dialogTableData = this.dialogTableData.concat(this.pushItem(10))
      } else {
        this.dialogTableData.splice(index, 0, {})
      }
    },
    async deleteDialogRow({ $index, row }) {
      if (this.dialogTableData.length <= 1) return
      const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      this.dialogTableData.splice($index, 1)
    },
    customerInputFocus () {
      this.$refs['customerSelectRef'].blur()
      window.top.openDialog55('选择客户', '/Account/sys/common/customerSelect.html?tag=SpecialPriceCustomer')
    },
    async getTableList() {
      this.tableLoading = true
      const { data: res } = await this.$http.post(
        '/Account/salSpecialPriceDefineForVue/selectSalSpecialPriceListForVue.html',
        this.Qs.stringify(this.params)
      );
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { data, total } = JSON.parse(res.result)
      this.total = total
      this.tableData = JSON.parse(data)
    },
    // 接受子页面数据
    messageOfSelect(e) {
      let { data: res } = e
      if (res.tag == 'SpecialPriceCustomer') {
        if (res.code != 'success') return false
          this.$set(this.queryForm.customer, 'list', res.data)
          this.queryForm.customer.selected = res.data
          top.layer.closeAll('iframe')
      }
    },
    onQuery() {
      this.params.page = 1
      Object.values(this.queryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          console.log(item)
          this.params['beginDate'] = item.selected ? (item.selected[0] || '') : ''
          this.params['endDate'] = item.selected ? (item.selected[1] || '') : ''
          return false
        } else if (toRawType(item.selected) == 'Array') {
          this.params[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'Object') {
            // if (['salOrderMeet', 'customer', 'brand', 'salesman'].includes(item.submitName)) {
            //   this.params[item.submitName + 'ID'] = item.selected.value || ''
            //   this.params[item.submitName + 'Name'] = item.selected.text || ''
            //   return false
            // }
            this.params[item.submitName] = item.selected.value || ''
        } else {
          if (item.selected) this.params[item.submitName] = item.selected
        }
      })
      this.getTableList()
    },
    handleSizeChange(newSize) {
      this.params.size = newSize
      this.getTableList()
    },
    // 翻页
    handleCurrentChange(newPage) {
      this.params.page = newPage
      this.getTableList()
    },
    // 筛选框打开时触发事件
    popoverShow (tag) {
      const popover = this.$refs['popover_' + tag]
      popover.$nextTick(() => {
        popover.$children[0].focus()
      })
    },
    // 其他自定义筛选
    tableFilter (tag) {
      this.$refs['popover_' + tag].doClose()
      let item = this.queryForm[tag]
      if (Array.isArray(item.selected)) {
        this.params[tag] = item.selected.map(element => ("'" + element.value + "'")).join(',')
        item.isFilter = item.selected.length ? true : false
      } else {
        this.params[tag] = item.selected
        item.isFilter = item.selected ? true : false
      }
      this.params.keyWords = this.params.planDesc
      this.params.page = 1
      this.getTableList()
    },
    handleTableDBClick({ planID }) {
      this.dialogVisible = true
      this.dialogParams.id = planID
      this.dialogStatus = 'edit'
      this.getDialogInfo()
    },
    async getDialogInfo() {
      this.dialogTableLoading = true
      const { data: res } = await this.$http.post(
        '/Account/SalSpecialPriceDefineDetailForVue/selectSpecialPriceVueDetailListForVue.html',
        this.Qs.stringify(this.dialogParams)
      );
      this.dialogTableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { data, total } = JSON.parse(res.result)
      let { headModel, domainIDs, promotionCustomerInfo, promotionItemInfo } = JSON.parse(data)
      console.log({ headModel, domainIDs, promotionCustomerInfo, promotionItemInfo })
      this.dialogQueryForm.billDate.selected = [headModel.beginDate || '', headModel.endDate || '']
      this.dialogQueryForm.id.selected = headModel.id
      this.dialogQueryForm.remark.selected = headModel.remark
      this.dialogQueryForm.planDesc.selected = headModel.planDesc
      this.dialogQueryForm.customerType.selected = headModel.customerType

      this.promotionCustomerInfo = promotionCustomerInfo.map(i => ({
        id: i.id,
        text: i.customerName,
        value: i.customerID
      }))
      this.domainSelection = domainIDs.map(i => ({
        id: i.id,
        text: i.domainDesc,
        firstId: i.firstId,
        secondId: i.secondId,
        value: i.domainID
      }))
      if (promotionItemInfo.length) {
        this.dialogTableData = promotionItemInfo.map(item => {
          if (item.largess == 'N') {
            item.unitQty = item.proBillQty
          } else {
            item.unitQty = item.largessQty
          }
          return item
        })
      }
    },
    copyRow({ row }) {
      this.dialogStatus = 'copy'
      this.dialogVisible = true
      this.dialogParams.id = row.planID
      this.getDialogInfo()
    },
    async cancelRow({ row }) {
      let tips = row.isEnabled != 'Y' ? '启用' : '作废'
      const confirmResult = await this.$confirm('此操作为' + tips + '操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消' + tips)
      const loading = this.$loading({
        lock: true,
        text: tips + '中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: res } = await this.$http.post(
        '/Account/promotionDefineForVue/updateSpecialPriceIsEnableForVue.html',
        this.Qs.stringify({
          id: row.planID,
          isEnabled: row.isEnabled != 'Y' ? 'Y' : 'N'
        })
      );
      loading.close()
      if (res.code != 'success') return this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      })
      this.$message.success(res.message)
      this.params.page = 1
      this.getTableList()
    },
    async deleteRow({ row }) {
      const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      const loading = this.$loading({
        lock: true,
        text: '删除中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const { data: res } = await this.$http.post(
        '/Account/promotionDefineForVue/deleteSpecialPriceForVue.html',
        this.Qs.stringify({
          id: row.planID
        })
      );
      loading.close()
      if (res.code != 'success') return this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      })
      this.$message.success(res.message)
      this.params.page = 1
      this.getTableList()
    },
    addDialog() {
      this.dialogStatus = 'add'
      this.dialogVisible = true
    },
    getProductData({ row, leaf }) {
      if (!leaf) {
        this.parameter.brandID = (row.value == 'all' ? '' : row.value)
        this.parameter.itemTypeID = ''
      } else {
        this.parameter.itemTypeID = (row.value == 'leafAll' ? '' : row.value)
      }
      try {
        this.dialogTableData.forEach((item, index) => {
          if (!item.itemName) {
            setTimeout(() => {
              this.tableCellClick(item, { property: 'itemName' })
            }, 300);
            throw item
          }
        })
      } catch (error) {
        
      }
    },
    customerTypeChange(val) {
      if (val == 'B') {
        this.dialogDomainVisible = true
      } else if (val == 'A') {
        this.dialogCustomerVisible = true
      }
    },
    domainSelect() {
      let selection = this.$refs.cascaderPanelDomain.selection
      console.log(selection)
      let arr = []
      selection.forEach(item => {
        if (item.checkedChildren.length && item.children.length) {
          item.checkedChildren.forEach($item => {
            arr.push({
              text: item.text + '-' + item.children.filter(i => i.value == $item)[0]?.text,
              value: $item,
              firstId: item.value,
              secondId: $item
            })
          })
        } else {
          arr.push({
            text: item.text,
            value: item.value,
            firstId: item.value,
            secondId: ''
          })
        }
      })
      this.domainSelection = arr
      this.dialogDomainVisible = false
    },
    tableCellClick(row, { property }) {
      if (['itemName', 'salSpecialPrice', 'midSpecialPrice', 'invSpecialPrice'].includes(property)) {
        this.$set(row, property + 'IsShow', true)
      }
    },
    itemNameSelect(item, row, index, next) {
      if (toRawType(item) == 'Array') {
        // let spaceRowNum = 0
        // let checkIsHasItemName = ($index) => {
        //   if (this.dialogTableData[$index] && this.dialogTableData[$index].itemName) {
        //     spaceRowNum += 1
        //     checkIsHasItemName(index + spaceRowNum)
        //   } else {
        //     return index + spaceRowNum
        //   }
        // }
        try {
          this.dialogTableData.forEach((i, iIndex) => {
            if (iIndex >= index) {
              if (!i.itemName) {
                this.$set(this.dialogTableData, iIndex, { ...i, ...item[0] })
                throw i
              }
            }
          })
        } catch (error) {
          
        }
        return false
      } else {
        row = { ...row, ...item }
        row['itemNameIsShow'] = false
        row[next + 'IsShow'] = true
        this.$set(this.dialogTableData, index, row)
      }
      this.checkRepeat({ $index: index, row }, 'salSpecialPrice', true)
    },
    numberInputBlur(val, { row, $index }, property, next) {
      this.$set(row, property + 'IsShow', false)
      if (next) {
        if (property == 'invSpecialPrice' && next == 'itemName' && this.dialogTableData[$index + 1]) {
          this.tableCellClick(this.dialogTableData[$index + 1], { property: next })
        } else {
          this.tableCellClick(row, { property: next })
        }
      }
    },
    handlePriceChange(val, { row }, property) {
      let { salSpecialPrice, midSpecialPrice, invSpecialPrice, salConversion, midConversion } = row
      if (property == 'salSpecialPrice') {
        midSpecialPrice = Number(toFixedRe(((Number(salSpecialPrice) || 0) / Number(salConversion) * Number(midConversion)), 4)).toString()
        invSpecialPrice = Number(toFixedRe(((Number(salSpecialPrice) || 0) / Number(salConversion)), 4)).toString()
      } else if (property == 'midSpecialPrice') {
        salSpecialPrice = Number(toFixedRe(((Number(midSpecialPrice) || 0) / Number(midConversion) * Number(salConversion)), 4)).toString()
        invSpecialPrice = Number(toFixedRe(((Number(midSpecialPrice) || 0) / Number(midConversion)), 4)).toString()
      } else if (property == 'invSpecialPrice') {
        salSpecialPrice = Number(toFixedRe(((Number(invSpecialPrice) || 0) * Number(salConversion)), 4)).toString()
        midSpecialPrice = Number(toFixedRe(((Number(invSpecialPrice) || 0) * Number(midConversion)), 4)).toString()
      }
      row.salSpecialPrice = salSpecialPrice
      row.midSpecialPrice = midSpecialPrice
      row.invSpecialPrice = invSpecialPrice
    },
    async onSubmit() {
      if (!this.dialogQueryItem.beginDate || !this.dialogQueryItem.endDate) return this.$message({
        showClose: true,
        message: '请先输入日期',
        type: 'error'
      })
      if (!this.dialogQueryItem.planDesc) return this.$message({
        showClose: true,
        message: '请先输入特价方案',
        type: 'error'
      })
      let promotionItemInfo = []
      let falg = false
      try {
        promotionItemInfo = this.dialogTableData.filter((item, index) => {
          if (item.itemName) {
            if (item.salSpecialPrice < 0 || item.midSpecialPrice < 0 || item.invSpecialPrice < 0) {
              this.$message({
                showClose: true,
                message: '第' + (index + 1) + '行, 特价不能小于零',
                type: 'error'
              })
              throw item
            }
            return true
          }
        })
      } catch (error) {
        falg = true
      }
      if (falg) return false
      if (promotionItemInfo.length <= 0) return this.$message({
        showClose: true,
        message: '请先录入商品',
        type: 'error'
      })
      let promotionCustomerInfo = []
      let domainIDs = []
      if (this.dialogQueryItem.customerType == 'B') {
        domainIDs = this.domainSelection.map(i => ({
          id: i.id,
          domainID: i.value
        }))
        if (!domainIDs.length) {
          return this.$message({
            showClose: true,
            message: '请选择片区',
            type: 'error'
          })
        }
      } else if (this.dialogQueryItem.customerType == 'A') {
        promotionCustomerInfo = this.promotionCustomerInfo.map(i => ({
          id: i.id,
          customerID: i.value
        }))
        if (!promotionCustomerInfo.length) {
          return this.$message({
            showClose: true,
            message: '请选择客户',
            type: 'error'
          })
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '提交中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        ...this.dialogQueryItem,
        specialPriceItemInfo: JSON.stringify(promotionItemInfo),
        specialPriceCustomerInfo: JSON.stringify(promotionCustomerInfo),
        domainIDs: JSON.stringify(domainIDs)
      }
      console.log(params)
      let url = '/Account/salSpecialPrice/salSpecialPriceDefineForVue/addSalSpecialPriceForVue.html'
      if (this.dialogStatus == 'edit') {
        url = '/Account/salSpecialPriceDefineForVue/updateSalSpecialPriceForVue.html'
      }
      const { data: res } = await this.$http.post(
        url,
        this.Qs.stringify(params)
      );
      loading.close()
      if (res.code != 'success') return this.$confirm(res.message, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      })
      this.$message.success(res.message)
      this.dialogVisible = false
      this.params.page = 1
      this.getTableList()
      console.log(res)
    },
    dialogClosed() {
      console.log(1)
      this.dialogQueryForm = {
        billDate: { submitName: 'billDate', selected: [] },
        planDesc: { submitName: 'planDesc', selected: '' },
        remark: { submitName: 'remark', selected: '' },
        customerType: { submitName: 'customerType', selected: 'C' },
        id: { submitName: 'id', selected: '' },
      }
      this.domainSelection = []
      this.promotionCustomerInfo = []
      this.dialogTableData = this.pushItem(20)
    },
    checkRepeat({ $index, row }, next, isCheck = false) {
      let flag = false
      const checkFn = ($index, row) => {
        let checked = false
        try {
          this.dialogTableData.forEach(async (item, index) => {
            const h = this.$createElement
            let htmlNode = [
              h('i', { style: 'color: teal' }, item.itemName),
              h('span', null, '第'),
              h('i', { style: 'color: #F56C6C' }, item.lineNum),
              h('span', null, '行已经录入，是否合并?')
            ]
            if (isCheck) {
              checked = row.itemID && index != $index && (('' + item.itemID + item.isLargess + item.productionDate + item.flavorID) == ('' + row.itemID + row.isLargess + row.productionDate + row.flavorID))
              htmlNode.unshift(h('span', null, '行的'))
              htmlNode.unshift(h('i', { style: 'color: #F56C6C' }, $index + 1))
              htmlNode.unshift(h('span', null, '第'))
            } else {
              checked = row.itemID && index != $index && ((item.itemID) == (row.itemID))
            }
            if (checked) {
              flag = true
              const confirmResult = await this.$msgbox({
                title: '提示',
                message: h('p', null, htmlNode),
                showCancelButton: !isCheck,
                confirmButtonText: '合并',
                cancelButtonText: '追加',
                type: 'warning'
              }).catch(err => err)
              if (confirmResult == 'confirm') {
                this.$set(this.dialogTableData, $index, {})
                this.tableCellClick(this.dialogTableData[index], { property: 'salSpecialPrice' })
              } else if (confirmResult == 'cancel') {
                if (isCheck) {
                  this.$set(this.dialogTableData, $index, {})
                  this.tableCellClick(this.dialogTableData[index], { property: 'salSpecialPrice' })
                  return false
                }
                this.tableCellClick(this.dialogTableData[$index], { property: next })
              }
              throw item
            }
          })
        } catch (e) {
        }
      }
      if (isCheck) {
        this.dialogTableData.forEach(($$item, $$index) => {
          checkFn($$index, $$item)
        })
      } else {
        checkFn($index, row)
      }

      return flag
    },
    getCustomer(row) {
      console.log(row)
      this.promotionCustomerInfo = row
      this.dialogCustomerVisible = false
    }
  }
}
</script>

<style scoped lang="less">
.query_btn_group {
  display: flex;
}

.query_btn_group .el-button {
  margin-left: 6px;
  color: #606266;
}

.query_btn_group .el-button:hover {
  color: #409EFF;
}

.reference {
  cursor: pointer;
}
.reference.highlight label {
  color: #409EFF;
}
::v-deep .select_multiple .el-select__tags {
  /*display: block;*/
  max-height: 32px;
  overflow: auto;
}
.el-main {
  padding: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .table {
    display: block;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
    ::v-deep .el-table {
      .index {
        div {
          padding: 0;
          text-align: center;
        }
      }
      .caozuo {
        .el-button {
          font-size: 16px;
          & + .el-button {
            margin-left: 4px;
          }
        }
      }
      .el-table__cell {
        padding: 0;
      }
    }
  }
  .el-pagination {
    box-sizing: border-box;
    flex-shrink: 0;
  }
}
::v-deep .dialog {
  .main {
    height: 70vh;
    .el-card {
      .el-card__body {
        display: flex;
        height: calc(100% - 33px);
        & > div:nth-child(1) {
          margin-right: 10px;
          .el-form {
            .el-form-item {
              width: 100%;
              .el-form-item__content {
                width: 100%;
              }
            }
          }
        }
        & > div:nth-child(2) {
          width: 300px;
          flex-shrink: 0;
        }
        .el-form {
          height: auto;
        }
      }
    }
    .dialogTable {
      display: flex;
    }
    .el-radio-group {
      display: flex;
      flex-flow: column;
      margin-top: 12px;
      .el-radio + .el-radio {
        margin-top: 6px;
      }
    }
    .customerType {
      height: 100%;
      .el-scrollbar {
        height: 100%;
        width: 100%;
        li {
          text-align: center;
          list-style: none;
        }
      }
    }
    .el-input-number {
      input {
        padding: 0;
        text-align: left;
      }
    }
  }
}
::v-deep .dialogDomain {
  .el-card.cardDomain {
    height: 50vh;
    .el-card__body {
      height: 100%;
      padding: 0;
    }
  }
}
::v-deep .dialogCustomer {
  height: 90vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .el-dialog__header,
  .el-card__header {
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .el-dialog__body {
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
  }
}
::v-deep .dialog,
::v-deep .dialogDomain {
  .el-dialog__footer{
    text-align: center;
  }
}
::v-deep .el-card {
  box-sizing: border-box;
  flex-shrink: 0;
  .el-card__header {
    padding: 8px 20px;
    height: 33px;
    background-color: #F5F7FA;
    color: #409EFF;
    font-size: 14px;
  }

  .el-card__body {
      padding: 12px;
      .query_form {
        .el-form-item {
          position: relative;
          .el-form-item__label {
            position: absolute;
            z-index: 2;
            top: -12px;
            margin-left: 10px;
            padding: 0 6px;
            line-height: normal;
            background-color: #fff;
            color: #000;
          }
        }
      }
      .el-form {
          display: flex;
          height: 100%;
          & + .el-form {
            margin-top: 12px;
          }
          .el-scrollbar {
              height: 100%;
          }

          .el-form-item {
              margin: 0;
              & + .el-form-item {
                margin-left: 10px;
              }
              .amt-info {
                  border: 1px #F56C6C solid;
                  color: #F56C6C;

                  span {
                      display: block;
                      text-align: center;
                  }
              }
          }
      }

      .calculation-form {
          .el-form-item {
              text-align: center;

              .el-form-item__label {
                  margin: 0;
                  left: 36px;
              }

              .input-with-select {
                  .el-input-group__prepend {
                      padding: 0 12px;
                      background-color: #fff;

                      .select-multiple {
                          display: inline-block;
                          width: 50px;
                      }
                  }
              }

              .el-input-number .el-input__inner {
                  text-align: left;
              }
          }
      }
  }
}
</style>